/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 *document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// ============================================
// API Configuration - Auto-detect environment
// ============================================
const API_BASE_URL = (function() {
  const hostname = window.location.hostname;
  // Check if running locally (localhost or 127.0.0.1)
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000';
  }
  // Production environment
  return 'https://stanosapi.peachmode.com';
})();

console.log('API Base URL:', API_BASE_URL);


function generateOrderTable(res){
  let data = `<table class="line-item-table table table--loose table--footered">
                  <thead class="line-item-table__header-group hidden-phone">
                     <tr>
                        <th><span class="heading heading--xsmall text--subdued">Product</span></th>
                        <th><span class="heading heading--xsmall text--subdued text--center">Quantity</span></th>
                        <th><span class="heading heading--xsmall text--subdued text--right">MRP</span></th>
                        <th><span class="heading heading--xsmall text--subdued text--right">Discount</span></th>
                        <th><span class="heading heading--xsmall text--subdued text--right">Net Amount</span></th>
                     </tr>
                  </thead>
                  <tbody class="line-item-table__list">`;
				  for ( item of res.order.items ){
                 data+= `<tr class="line-item">
                        <td class="line-item__product">
                           <div class="line-item__content-wrapper">
                              <div class="line-item__image-wrapper">
<img   class="line-item__image" loading="sizes" sizes="(max-width: 740px) 80px, 92px" height="2000" width="2000" alt="" src="${item.image}" >
                              </div>
                              <div class="line-item__info" style="width: 100%;">
                                 <div class="product-item-meta" style="width: 100%;">
                                    <div class="product-item-meta__title text--small hidden-tablet-and-up">${item.name}</div>
                                    <div class="product-item-meta__title hidden-phone">${item.name}</div>
                                    ${item.color ? `<div class="text--subdued text--xsmall">Color: ${item.color}</div>` : ''}
                                    ${item.size ? `<div class="text--subdued text--xsmall">Size: ${item.size}</div>` : ''}
                                    <div class="hidden-tablet-and-up" style="margin-top: 12px; font-size: 13px; line-height: 1.6; max-width: 100%;">
                                       <div style="display: flex; justify-content: space-between; align-items: center; padding: 6px 0; border-bottom: 1px solid #f0f0f0;">
                                         <span style="color: #666;">Quantity</span>
                                         <span style="color: #333; font-weight: 500;">${item.quantity}</span>
                                       </div>
                                       <div style="display: flex; justify-content: space-between; align-items: center; padding: 6px 0; border-bottom: 1px solid #f0f0f0;">
                                         <span style="color: #666;">MRP</span>
                                         <span style="color: #333; font-weight: 500;">₹${item.mrpAmount}</span>
                                       </div>
                                       <div style="display: flex; justify-content: space-between; align-items: center; padding: 6px 0; border-bottom: 1px solid #f0f0f0;">
                                         <span style="color: #666;">Discount</span>
                                         <span style="color: #16a34a; font-weight: 600;">-₹${item.discountAmount}</span>
                                       </div>
                                       <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0 0 0;">
                                         <span style="color: #333; font-weight: 600;">Net Amount</span>
                                         <span style="color: #333; font-weight: 700; font-size: 15px;">₹${item.netAmount}</span>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </td>
                        <td class="line-item__quantity text--center hidden-phone">
                           <div style="line-height: 1.5">${item.quantity}</div>
                        </td>
                        <td class="line-item__price-list-container text--right hidden-phone">
                           <div class="price-list price-list--stack"><span class="price">₹${item.mrpAmount}</span></div>
                        </td>
                        <td class="line-item__price-list-container text--right hidden-phone">
                           <div class="price-list price-list--stack"><span class="price" style="color: #16a34a;">-₹${item.discountAmount}</span></div>
                        </td>
                        <td class="line-item__price-list-container text--right hidden-phone">
                           <div class="price-list price-list--stack"><span class="price"><strong>₹${item.netAmount}</strong></span></div>
                        </td>
                     </tr>`;
					} 
                data+=  `</tbody>
                  <tfoot class="line-item-table__footer">
                     <!-- Mobile: All totals - 2nd cell gets 100% width per theme CSS -->
                     <tr class="hidden-tablet-and-up">
                        <td></td>
                        <td style="padding: 12px 0;">
                          <div style="font-size: 13px;">
                            <div style="display: flex; justify-content: space-between; align-items: center; padding: 6px 0; border-bottom: 1px solid #f0f0f0;">
                              <span style="color: #666;">Total MRP</span>
                              <span style="color: #333; font-weight: 600;">₹${res.order.totalMrpAmount}</span>
                            </div>
                            <div style="display: flex; justify-content: space-between; align-items: center; padding: 6px 0; border-bottom: 1px solid #f0f0f0;">
                              <span style="color: #666;">Total Discount</span>
                              <span style="color: #16a34a; font-weight: 600;">-₹${res.order.totalDiscountAmount}</span>
                            </div>
                            <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0 0 0;">
                              <span style="color: #333; font-weight: 700;">Total Amount</span>
                              <span style="color: #333; font-weight: 700; font-size: 16px;">₹${res.order.totalNetAmount}</span>
                            </div>
                          </div>
                        </td>
                     </tr>
                     <!-- Desktop: ALL Totals in ONE row, aligned in respective columns -->
                     <tr class="text--strong hidden-phone" style="border-top: 2px solid #e5e7eb;">
                        <td colspan="2" style="padding-top: 15px;"><strong>Totals</strong></td>
                        <td class="text--right" style="padding-top: 15px;"><strong>₹${res.order.totalMrpAmount}</strong></td>
                        <td class="text--right" style="color: #16a34a; padding-top: 15px;"><strong>-₹${res.order.totalDiscountAmount}</strong></td>
                        <td class="text--right" style="padding-top: 15px;"><strong>₹${res.order.totalNetAmount}</strong></td>
                     </tr>
                  </tfoot>
               </table>`;
  $(".order_table").html(data);

}

// Helper function to get payment method from transactions
function getPaymentMethod(order) {
  // Try to get from paymentTransactions array
  if(order.paymentTransactions && order.paymentTransactions.length > 0) {
    // Find the first SALE transaction to get the payment method
    const saleTransaction = order.paymentTransactions.find(txn => txn.kind === 'SALE');
    if(saleTransaction) {
      return saleTransaction.gateway || 'N/A';
    }
    // If no SALE, return first transaction gateway
    return order.paymentTransactions[0].gateway || 'N/A';
  }
  
  // Fallback to old payment structure if it exists
  if(order.payment && order.payment.method) {
    return order.payment.method.replace("Cash on Delivery (COD)", "COD");
  }
  
  return 'N/A';
}

// Function to display payment transactions
function displayPaymentTransactions(transactions) {
  if(!transactions || transactions.length === 0) return;
  
  // Sort by processedAt in descending order (latest first)
  const sortedTransactions = [...transactions].sort((a, b) => new Date(b.processedAt) - new Date(a.processedAt));
  
  // Show the payment transactions section
  $(".payment_transactions_section").slideDown();
  
  let html = '<div class="payment_timeline" style="position: relative; padding-left: 30px;">';
  
  sortedTransactions.forEach((txn, index) => {
    const isFirst = index === 0;
    const isLast = index === sortedTransactions.length - 1;
    
    // Determine color based on kind and status
    let txnColor = '#6b7280'; // Default grey
    let bgColor = '#f9f9f9';
    let badgeText = txn.kind;
    let badgeBg = '#6b7280';
    
    if(txn.status === 'SUCCESS') {
      if(txn.kind === 'SALE') {
        txnColor = '#16a34a'; // Green for successful payment
        bgColor = isFirst ? '#f0f8f0' : '#f9f9f9';
        badgeBg = '#16a34a';
        badgeText = 'PAYMENT';
      } else if(txn.kind === 'REFUND') {
        txnColor = '#3b82f6'; // Blue for refund
        bgColor = isFirst ? '#dbeafe' : '#f9f9f9';
        badgeBg = '#3b82f6';
        badgeText = 'REFUND';
      }
    } else if(txn.status === 'FAILURE') {
      txnColor = '#dc2626'; // Red for failed transaction
      bgColor = isFirst ? '#fee2e2' : '#f9f9f9';
      badgeBg = '#dc2626';
      badgeText = txn.kind + ' FAILED';
    }
    
    const txnDate = new Date(txn.processedAt).toLocaleString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
    
    html += `
      <div class="payment_item" style="position: relative; padding-bottom: 30px; ${isLast ? 'padding-bottom: 0;' : ''}">
        <!-- Timeline dot -->
        <div style="position: absolute; left: -30px; top: 0; width: 12px; height: 12px; border-radius: 50%; background: ${txnColor}; border: 2px solid ${txnColor};"></div>
        
        <!-- Timeline line -->
        ${!isLast ? '<div style="position: absolute; left: -25px; top: 12px; width: 2px; height: calc(100% + 5px); background: #ddd;"></div>' : ''}
        
        <!-- Content -->
        <div style="background: ${bgColor}; padding: 15px; border-radius: 5px; border-left: 3px solid ${txnColor};">
          <div style="margin-bottom: 8px; display: flex; align-items: center; gap: 10px;">
            <strong style="color: ${txnColor}; font-size: 16px;">₹${txn.amount}</strong>
            <span style="background: ${badgeBg}; color: white; font-size: 10px; padding: 3px 8px; border-radius: 3px; font-weight: 600;">${badgeText}</span>
            ${isFirst ? '<span style="background: #666; color: white; font-size: 10px; padding: 3px 6px; border-radius: 3px;">LATEST</span>' : ''}
          </div>
          <div style="font-size: 13px; color: #666; margin-bottom: 8px;">
            <strong>Gateway:</strong> ${txn.gateway}
          </div>
          <div style="font-size: 12px; color: #999;">
            <div><strong>Status:</strong> <span style="color: ${txnColor};">${txn.status}</span></div>
            <div><strong>Processed At:</strong> ${txnDate}</div>
            ${txn.authorizationCode ? `<div><strong>Auth Code:</strong> ${txn.authorizationCode}</div>` : ''}
            ${txn.message ? `<div><strong>Message:</strong> ${txn.message}</div>` : ''}
            ${txn.errorCode ? `<div style="color: #dc2626;"><strong>Error:</strong> ${txn.errorCode}</div>` : ''}
          </div>
        </div>
      </div>
    `;
  });
  
  html += '</div>';
  $("#payment_transactions_container").html(html);
}

// Function to get timeline configuration based on shipment status
function getTimelineConfig(shipment) {
  const status = shipment.status;
  // Check if there's a delay either in status or tracking history
  const hasDelay = status == 'DELAYED' || (shipment.trackingHistory && shipment.trackingHistory.some(h => h.status.toUpperCase().includes('DELAY')));
  
  // Determine timeline steps based on status
  let steps = [];
  let activeStep = 0;
  let finalStatusColor = '';
  let finalStatusText = '';
  
  // Check actual delivery date
  const deliveryDate = shipment.actualDeliveryDate ? 
    ` (${new Date(shipment.actualDeliveryDate).toLocaleDateString('en-IN', {day: 'numeric', month: 'short', year: 'numeric'})})` : '';
  
  if(hasDelay) {
    // Timeline with DELAYED step: Created -> In Transit -> Delayed -> Final
    steps = [
      {label: 'Shipment Created', status: 'CONFIRMED'},
      {label: 'In Transit', status: 'IN_TRANSIT'},
      {label: 'Delayed', status: 'DELAYED', color: '#f59e0b'},
      {label: status == 'DELIVERED' ? 'Delivered' : status == 'FAILURE' ? 'Failed' : 'Final', status: 'FINAL'}
    ];
    
    if(status == 'CONFIRMED') activeStep = 0;
    else if(status == 'IN_TRANSIT') activeStep = 1;
    else if(status == 'DELAYED') activeStep = 2;
    else if(status == 'DELIVERED' || status == 'FAILURE') activeStep = 3;
    
  } else {
    // Normal timeline: Created -> In Transit -> Final
    steps = [
      {label: 'Shipment Created', status: 'CONFIRMED'},
      {label: 'In Transit', status: 'IN_TRANSIT'},
      {label: status == 'DELIVERED' ? 'Delivered' : status == 'FAILURE' ? 'Failed' : 'Delivered', status: 'FINAL'}
    ];
    
    if(status == 'CONFIRMED') activeStep = 0;
    else if(status == 'IN_TRANSIT') activeStep = 1;
    else if(status == 'DELIVERED' || status == 'FAILURE') activeStep = 2;
  }
  
  // Set final status color and text
  if(status == 'DELIVERED') {
    finalStatusColor = '#16a34a'; // Green
    finalStatusText = 'Delivered' + deliveryDate;
    steps[steps.length - 1].color = finalStatusColor;
    steps[steps.length - 1].label = finalStatusText;
  } else if(status == 'FAILURE') {
    finalStatusColor = '#dc2626'; // Red
    finalStatusText = 'Failed' + deliveryDate;
    steps[steps.length - 1].color = finalStatusColor;
    steps[steps.length - 1].label = finalStatusText;
  } else if(status == 'DELAYED') {
    finalStatusColor = '#f59e0b'; // Yellow for delayed
  }
  
  return {steps, activeStep, finalStatusColor};
}

// Function to generate timeline HTML
function generateTimelineHTML(config) {
  const {steps, activeStep} = config;
  const stepWidth = 100 / steps.length;
  
  // Check if final status is FAILURE
  const isFailed = steps[steps.length - 1].label.includes('Failed');
  
  let timelineHTML = `
    <div class="tracking_slider" style="margin-top: 25px; padding: 0 5px;">
      <div class="track_bar" style="display: flex; position: relative; height: 4px; background: #e5e7eb; border-radius: 2px; margin-bottom: 15px;">`;
  
  // Generate progress bars
  for(let i = 0; i < steps.length - 1; i++) {
    const isActive = i < activeStep;
    // Use step-specific color if step is DELAYED and active, otherwise use default
    let barColor = '#e5e7eb'; // default inactive
    if(isActive) {
      if(steps[i].status === 'DELAYED') {
        barColor = steps[i].color; // Yellow for delayed
      } else if(isFailed) {
        barColor = '#dc2626'; // Red for failed shipments
      } else {
        barColor = '#2c5f2d'; // Green for normal active
      }
    }
    timelineHTML += `
      <span style="flex: 1; height: 100%; background: ${barColor}; ${i > 0 ? 'margin-left: 2px;' : ''}"></span>`;
  }
  
  timelineHTML += `
      </div>
      <div class="d-flex flex-wrap flex-1 justify-between align-center" style="display: flex; justify-content: space-between; flex-wrap: wrap; gap: 10px;">`;
  
  // Generate step labels
  steps.forEach((step, index) => {
    const isActive = index <= activeStep;
    let color;
    
    if(step.color) {
      // Use step-specific color (e.g., yellow for delayed, red/green for final)
      color = step.color;
    } else if(isActive && isFailed && index < steps.length - 1) {
      // Use red for active steps when shipment failed
      color = '#dc2626';
    } else if(isActive) {
      // Use green for normal active steps
      color = '#2c5f2d';
    } else {
      // Use gray for inactive steps
      color = '#6b7280';
    }
    
    const fontWeight = index === activeStep ? 'bold' : 'normal';
    
    timelineHTML += `
      <span style="color: ${color}; font-weight: ${fontWeight}; font-size: 11px; text-align: ${index === 0 ? 'left' : index === steps.length - 1 ? 'right' : 'center'}; flex: 1; min-width: 60px; padding: 8px 2px; line-height: 1.3; word-break: break-word;">
        ${step.label}
      </span>`;
  });
  
  timelineHTML += `
      </div>
    </div>`;
  
  return timelineHTML;
}

// Function to display all shipments
function displayAllShipments(shipments, order, orderid, email, phone) {
  $("#all_shipments_container").empty();
  
  shipments.forEach((shipment, index) => {
    const shipmentNumber = shipments.length > 1 ? ` #${index + 1}` : '';
    const shipmentId = `shipment_${index}`;
    
    // Get timeline configuration
    const timelineConfig = getTimelineConfig(shipment);
    const timelineHTML = generateTimelineHTML(timelineConfig);
    
    const shipmentHtml = `
      <div class="account__address account__address--auto shipment_item" style="margin-bottom: 40px; padding-bottom: 30px; border-bottom: 2px solid #eee;">
        ${shipments.length > 1 ? `<h3 class="heading h6" style="margin-bottom: 20px;">Shipment${shipmentNumber}</h3>` : ''}
        
        <ul class="tracking_details" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); list-style: none; padding: 0; margin: 0 0 30px 0; gap: 15px 30px;">
          <li style="padding: 10px; background: #f9f9f9; border-radius: 6px; font-size: 14px;"><strong style="display: block; margin-bottom: 6px; color: #666; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Tracking No</strong><span style="display: block; color: #333; font-weight: 600;">${shipment.trackingNumber}</span></li>
          <li style="padding: 10px; background: #f9f9f9; border-radius: 6px; font-size: 14px;"><strong style="display: block; margin-bottom: 6px; color: #666; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Courier</strong><span style="display: block; color: #333; font-weight: 600;">${shipment.carrierName}</span></li>
          <li style="padding: 10px; background: #f9f9f9; border-radius: 6px; font-size: 14px;"><strong style="display: block; margin-bottom: 6px; color: #666; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Status</strong><span style="display: block; color: ${timelineConfig.finalStatusColor || '#333'}; font-weight: 700;">${shipment.status ?? 'Not Available'}</span></li>
          <li style="padding: 10px; background: #f9f9f9; border-radius: 6px; font-size: 14px;"><strong style="display: block; margin-bottom: 6px; color: #666; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Payment</strong><span style="display: block; color: ${shipment.paymentStatus === 'PAID' ? '#16a34a' : shipment.paymentStatus === 'COD' || shipment.paymentStatus === 'PENDING' ? '#f59e0b' : '#333'}; font-weight: 700;">${shipment.paymentStatus ?? 'N/A'}</span>${shipment.amountToCollect > 0 ? `<span style="display: block; color: #f59e0b; font-size: 12px; margin-top: 4px; font-weight: 600;">COD: ₹${shipment.amountToCollect}</span>` : ''}</li>
        </ul>
        
        ${timelineHTML}
        
        <!-- Latest Tracking Scan -->
        <div class="tracking_history_section_${shipmentId} mt-4" style="display:none;">
          <h3 class="heading h6">Latest Scan</h3>
          <div class="latest_scan_container_${shipmentId}" style="padding: 15px; background: #f9f9f9; border-radius: 5px; margin-top: 10px;">
            <!-- Latest scan will be populated here -->
          </div>
          <div class="mt-3">
            <button type="button" class="button button--secondary button--small show_all_scans_btn" data-shipment-id="${shipmentId}">Show All Scans</button>
          </div>
        </div>
        
        <table class="line-item-table table table-shipment mt-4 mb-1">
          <thead class="line-item-table__header-group hidden-phone">
            <tr>
              <th><span class="">Shipment Items</span></th>
              <th><span class="text--center">Quantity</span></th>
              <th><span class="text--right">MRP</span></th>
              <th><span class="text--right">Discount</span></th>
              <th><span class="text--right">Net Amount</span></th>
            </tr>
          </thead>
          <tbody class="line-item-table__list shipment_html_${shipmentId}">
          </tbody>
          <tfoot class="line-item-table__footer">
            <!-- Mobile: Shipment total - 2nd cell gets 100% width per theme CSS -->
            <tr class="text--strong hidden-tablet-and-up">
              <td></td>
              <td style="padding: 12px 0;">
                <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0; font-size: 14px;">
                  <span style="color: #333; font-weight: 700;">Shipment Total</span>
                  <span style="color: #333; font-weight: 700; font-size: 16px;">₹${shipment.shipmentTotal}</span>
                </div>
              </td>
            </tr>
            <!-- Desktop: Shipment total aligned in last column -->
            <tr class="text--strong hidden-phone" style="border-top: 2px solid #e5e7eb;">
              <td colspan="2" style="padding-top: 15px;"><strong>Shipment Total</strong></td>
              <td style="padding-top: 15px;"></td>
              <td style="padding-top: 15px;"></td>
              <td class="text--right" style="padding-top: 15px;"><strong>₹${shipment.shipmentTotal}</strong></td>
            </tr>
          </tfoot>
        </table>
      </div>
    `;
    
    $("#all_shipments_container").append(shipmentHtml);
    
    // Generate shipment items table
    generateShipmentTableForId(shipment.items, order.orderStatus, false, orderid, email, phone, shipmentId);
    
    // Display tracking history if available
    if(shipment.trackingHistory && shipment.trackingHistory.length > 0){
      displayTrackingHistoryForShipment(shipment.trackingHistory, shipmentId);
    }
  });
}

// Modified function to generate shipment table for specific shipment ID
function generateShipmentTableForId(items, orderStatus, cancel, orderid, email, phone, shipmentId) {
  let data = "";
  if(items && items.length > 0) {
    for (let item of items) {
      data += `<tr class="line-item">
        <td class="line-item__product">
          <div class="line-item__content-wrapper">
            <div class="line-item__image-wrapper">
              <img class="line-item__image" loading="sizes" sizes="(max-width: 740px) 80px, 92px" height="2000" width="2000" alt="" src="${item.image}">
            </div>
            <div class="line-item__info" style="width: 100%;">
              <div class="product-item-meta" style="width: 100%;">
                <div class="product-item-meta__title text--small hidden-tablet-and-up">${item.name}</div>
                <div class="product-item-meta__title hidden-phone">${item.name}</div>
                ${item.color ? `<div class="text--subdued text--xsmall">Color: ${item.color}</div>` : ''}
                ${item.size ? `<div class="text--subdued text--xsmall">Size: ${item.size}</div>` : ''}
                <div class="hidden-tablet-and-up" style="margin-top: 12px; font-size: 13px; line-height: 1.6; max-width: 100%;">
                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 6px 0; border-bottom: 1px solid #f0f0f0;">
                    <span style="color: #666;">Quantity</span>
                    <span style="color: #333; font-weight: 500;">${item.quantity}</span>
                  </div>
                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 6px 0; border-bottom: 1px solid #f0f0f0;">
                    <span style="color: #666;">MRP</span>
                    <span style="color: #333; font-weight: 500;">₹${item.mrpAmount}</span>
                  </div>
                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 6px 0; border-bottom: 1px solid #f0f0f0;">
                    <span style="color: #666;">Discount</span>
                    <span style="color: #16a34a; font-weight: 600;">-₹${item.discountAmount}</span>
                  </div>
                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 8px 0 0 0;">
                    <span style="color: #333; font-weight: 600;">Net Amount</span>
                    <span style="color: #333; font-weight: 700; font-size: 15px;">₹${item.netAmount}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
        <td class="line-item__quantity text--center hidden-phone">
          <div style="line-height: 1.5">${item.quantity}</div>
        </td>
        <td class="line-item__price-list-container text--right hidden-phone">
          <div class="price-list price-list--stack">₹${item.mrpAmount}</div>
        </td>
        <td class="line-item__price-list-container text--right hidden-phone">
          <div class="price-list price-list--stack" style="color: #16a34a;">-₹${item.discountAmount}</div>
        </td>
        <td class="line-item__price-list-container text--right hidden-phone">
          <div class="price-list price-list--stack"><strong>₹${item.netAmount}</strong></div>
        </td>
      </tr>`;
    }
  }
  $(`.shipment_html_${shipmentId}`).html(data);
}

function generateShipmentTable(res,shipment_status,cancel=false,orderid="",email="",phone="",returns = null){
  //console.log(res,shipment_status,cancel,orderid,email,phone);
  let data = "";
   if( res != null ){
   for ( item of res ){
      data+= `<tr class="line-item">
                        <td class="line-item__product">
                           <div class="line-item__content-wrapper">
                              <div class="line-item__image-wrapper">
                              <img  class="line-item__image" loading="sizes" sizes="(max-width: 740px) 80px, 92px" height="2000" width="2000" alt="" src="${item.image}" >
                              </div>
                              <div class="line-item__info">
                                 <div class="product-item-meta">
                                    <div class="product-item-meta__title text--small hidden-tablet-and-up">${item.name}</div>
                                    <div class="product-item-meta__title hidden-phone">${item.name}</div>
                                    <div class="product-item-meta__price-list-container">
                                       <div class="price-list text--small hidden-tablet-and-up">${item.size ? 'Size: ' + item.size : ''}
                                       </div>
                                       <div class="price-list">SKU: ${item.barcode}
                                       </div>
                                       ${item.color ? `<div class="price-list">Color: ${item.color}</div>` : ''}
                                    </div>
                                 </div>
                                 <div class="line-item__quantity hidden-tablet-and-up text--xsmall">Quantity: ${item.quantity}</div>
                              </div>
                           </div>
                        </td>
                        <td class="line-item__quantity text--center hidden-phone">
                           <div style="line-height: 1.5">${item.size ?? 'N/A'}</div>
                        </td>
                        <td class="line-item__price-list-container text--center hidden-phone">
                           <div class="price-list price-list--stack">${item.quantity}
                           </div>
                        </td>
                     </tr>`;
   }
}
  if(cancel == true){
     console.log(shipment_status);
  if(shipment_status == null || (shipment_status != "COMPLETE" && shipment_status != "fulfilled")){
  data+=`<tr>
        <td colspan="3">
         <form id="cancel-order-form"  method="post" style="display: flex; align-items: center; margin-top:2rem;">
<input type="hidden" id="orderid" value="${orderid}" />
             <input type="hidden" id="billing_email" value="${email}" />
             <input type="hidden" id="billing_phone" value="${phone}" />
 <div class="input">
          <select id="cancelreason"   class="input__field is-filled" id="cancelreason" name="cancelreason" aria-label="cancelreason" required >
          <option value="">Select</option>  
                                          <option value="Wrongly Placed">Wrongly Placed</option>
                                          <option value="Want to use store credit">Want to use store credit</option>
                                          <option value="Out of station">Out of station</option>
                                          <option value="COD not available">COD not available</option>
                                          <option value="Did not like colour">Did not like colour</option>
                                          <option value="Not happy with policy">Not happy with policy</option>
                                          <option value="Low prices on other website">Low prices on other websites</option>
                                          <option value="Delivery time issue">Delivery time issue</option>
                                          <option value="Want to pay online">Want to pay online</option>
                                          <option value="Product not as per requirement">Product not as per requirement</option>
                                          <option value="Other">Other</option>
                                          </select>
           <label for="cancelreason" class="input__label">Select Cancel Reason*</label>
        </div>
 <button is="loader-button" style="padding: 18px; margin-left: 20px;    margin-top: 0;" type="submit" class="form__submit button button--primary">Cancel Order</button>
         
         </form>
        <p id="cancelError"></p>
       </td>
    </tr>`;
    }else if( shipment_status == "CANCELLED" || shipment_status == "canceled"){
      data+=`<tr>
        <td colspan="3">
<p style="color:red">Your order is cancelled. For any queries please contact customer care</p>
        </td>

        </tr>`;
    }else if( shipment_status == "COMPLETE" || shipment_status == "fulfilled"){
         if( returns != null ){
           for ( item of returns[0].products ){
              data+= `<tr class="line-item">
                                <td class="line-item__product">
                                   <div class="line-item__content-wrapper">
                                      <a href="" class="line-item__image-wrapper"  >
                                      <img  class="line-item__image" loading="sizes" sizes="(max-width: 740px) 80px, 92px" height="2000" width="2000" alt="" src="${item.product.product.baseimage[0].src}" >
                                      </a>
                                      <div class="line-item__info">
                                         <div class="product-item-meta">
                                            <a href="/products/${item.product.product.handle}" class="product-item-meta__title text--small hidden-tablet-and-up">${item.product.title}</a>
                                            <a href="/products/${item.product.product.handle}" class="product-item-meta__title hidden-phone">${item.product.title}</a>
                                            <div class="product-item-meta__price-list-container">
                                               <div class="price-list text--small hidden-tablet-and-up">₹${item.product.price}
                                               </div>
                                               <div class="price-list">
                                                  SKU: ${item.product.sku}<br/>
                                               Reason:  ${item.reason}
                                               </div>
                                            </div>
                                         </div>
                                         <div class="line-item__quantity hidden-tablet-and-up text--xsmall">Quantity: ${item.product.quantity}</div>
                                      </div>
                                   </div>
                                </td>
                                <td class="line-item__quantity text--center hidden-phone">
                                   <div style="line-height: 1.5">₹${item.product.price}</div>
                                </td>
                                <td class="line-item__price-list-container text--center hidden-phone">
                                   <div class="price-list price-list--stack">${item.product.quantity}
                                   </div>
                                </td>
                             </tr>`;
           }
           
            $(".tracking_details li:nth-child(1) span").html(returns[0].tracking_number);
    	             $(".tracking_details li:nth-child(2) span").html(returns[0].action);
	                 $(".tracking_details li:nth-child(3) span").html(returns[0].return_status??"Not Available");
                     $(".tracking_details li:nth-child(4) span").html("COD");
                    $(".tracking_details li:nth-child(5) span").html("₹"+returns[0].refund_amount);
                let barClass = "";
                let returnStatus = returns[0].return_status; 
                    if(returnStatus == "Initiated Return"){
                      $(".tracking_slider .progressbar li:nth-child(1)").addClass("active");
                    }else if(returnStatus == "Package In Transit"){
                      $(".tracking_slider .progressbar li:nth-child(1),.tracking_slider .progressbar li:nth-child(2)").addClass("active");
                    } else if(returnStatus == "Package Received"){
                      $(".tracking_slider .progressbar li:nth-child(1),.tracking_slider .progressbar li:nth-child(2),.tracking_slider .progressbar li:nth-child(3)").addClass("active");
                    }else if(returnStatus == "Complete"){
                      $(".tracking_slider .progressbar li").addClass("active");
                    }else if(returnStatus == "Cancelled"){
                        $(".tracking_slider .progressbar li:nth-child(2),.tracking_slider .progressbar li:nth-child(3)").hide();
                         $(".tracking_slider .progressbar li").addClass("active").css("width","50%");
                         $(".tracking_slider .progressbar li:nth-child(4) span").html("Cancelled");
                     }
                    $(".track_bar").addClass(barClass);
                    if(returns[0].tracking_url != null)
                 	 $(".track_url").attr("href",returns[0].tracking_url); 
                    else
                      $(".track_url").hide(); 
           
                    $(".if_returned_heading,.return_orders tfoot th,table.table-shipment + table").slideUp();
                    $(".if_returned").slideDown(); 
           
         }else{
          data+=`<tr>
        <td colspan="3">
<p style="color:red">Order Can't be cancelled. For any queries please contact customer care</p>
        </td>

        </tr>`;
         }
    }else{
            data+=`<tr>
        <td colspan="3">
<p style="color:red">Order Can't be cancelled. For any queries please contact customer care</p>
        </td>

        </tr>`;
    }
  }
     $(".shipment_html").html(data);
}
   $("#return-and-track-order-form").on("submit",function(e){
       e.preventDefault();
     let formhasClass = $(this);
     $("#trackerError,#shipmentError").html("");
     if($('[name="orderid"]').val().match(/(\d+)/)){
       let orderid = $('[name="orderid"]').val().match(/(\d+)/)[0].replace(/" "/g,"");
     let email = $('[name="billing_email"]').val().replace(/" "/g,"");
      let phone = $('[name="billing_phone"]').val().replace(/" "/g,"").replace(/^\+91/,"");
      $.ajax({
             url: API_BASE_URL + '/api/public/track-order?orderNumber='+orderid+'&phone='+phone+'&email='+email, 
             type: 'get', 
             success: function(res){
               // console.log(res);
               if( res.success && res.order){
                   $(".order_name").html("Order "+res.order.orderNumber)
                   $(".order_date").html(new Date(res.order.orderDate).toLocaleDateString());
                   
                   // Display order status with color coding
                   let orderStatusColor = '#6b7280'; // Default grey
                   let orderStatusText = res.order.orderStatus;
                   
                   if(res.order.orderStatus === 'COMPLETE') {
                     orderStatusColor = '#16a34a'; // Green for complete
                   } else if(res.order.orderStatus === 'PARTIALLY_COMPLETE') {
                     orderStatusColor = '#f59e0b'; // Yellow for partially complete
                     orderStatusText = 'PARTIALLY COMPLETE';
                   } else if(res.order.orderStatus === 'CANCELLED') {
                     orderStatusColor = '#dc2626'; // Red for cancelled
                   } else if(res.order.orderStatus === 'CONFIRMED') {
                     orderStatusColor = '#3b82f6'; // Blue for confirmed
                   }
                   $(".order_status").html(`<span style="display: inline-block; padding: 6px 12px; background: ${orderStatusColor}; color: white; border-radius: 4px; font-size: 13px; font-weight: 600;">Order Status: ${orderStatusText}</span>`);
                   
                  // Handle cancel order functionality
                  if(res.canCancel !== undefined) {
                    if(res.canCancel === true) {
                      // Show cancel button
                      $(".order_actions_section").show();
                      $(".cancel_order_btn").show();
                      $(".cancel_message").hide();
                      // Store order info for cancellation
                      window.currentOrder = {
                        orderNumber: orderid,
                        email: email,
                        phone: phone
                      };
                    } else {
                      // Show cancel message
                      if(res.cancelMessage) {
                        $(".order_actions_section").show();
                        $(".cancel_order_btn").hide();
                        $(".cancel_message").html(res.cancelMessage).show();
                      }
                    }
                  }
                  
                  // Handle return eligibility
                  if(res.returnEligibility !== undefined) {
                    if(res.returnEligibility.canCreateReturn === true) {
                      // Show create return button
                      $(".order_actions_section").show();
                      $(".create_return_btn").show();
                      $(".return_eligibility_message").hide();
                      // Store return eligibility and order info
                      window.returnEligibility = res.returnEligibility;
                      window.currentOrder = window.currentOrder || {
                        orderNumber: orderid,
                        email: email,
                        phone: phone
                      };
                      // Pre-fill pickup address with shipping address
                      window.pickupAddressDefault = {
                        address1: res.order.shippingAddress.address1,
                        address2: res.order.shippingAddress.address2,
                        city: res.order.shippingAddress.city,
                        state: res.order.shippingAddress.state,
                        postalCode: res.order.shippingAddress.postalCode,
                        phone: res.order.customer.phone.replace(/^\+91/, '')
                      };
                    } else {
                      // Show return eligibility message if no returns yet
                      if(!res.returns || res.returns.length === 0) {
                        if(res.returnEligibility.reason) {
                          $(".order_actions_section").show();
                          $(".create_return_btn").hide();
                          $(".return_eligibility_message").html(res.returnEligibility.reason).show();
                        }
                      }
                    }
                  }
                   
                 $(".billing_address p").html(res.order.customer.name+"<br/>"+res.order.shippingAddress.address1+" "+res.order.shippingAddress.address2+"<br/>"+res.order.shippingAddress.postalCode+" "+res.order.shippingAddress.city+" "+res.order.shippingAddress.state+"<br/>"+res.order.shippingAddress.country);
                 $(".shipping_address p").html(res.order.customer.name+"<br/>"+res.order.shippingAddress.address1+" "+res.order.shippingAddress.address2+"<br/>"+res.order.shippingAddress.postalCode+" "+res.order.shippingAddress.city+" "+res.order.shippingAddress.state+"<br/>"+res.order.shippingAddress.country);
                 
                 // Display payment transactions if available
                 if(res.order.paymentTransactions && res.order.paymentTransactions.length > 0) {
                   displayPaymentTransactions(res.order.paymentTransactions);
                 }
                 
                if(formhasClass.hasClass("cancel_order")){
                  let shipmentItems = null
                  if(res.shipments && res.shipments.length>0){
                    shipmentItems = res.shipments[0].items;
                  }else{
                   $(".table-shipment thead").css("display","none"); 
                  }
                   generateShipmentTable(shipmentItems,res.order.orderStatus,true,orderid,email,phone);
                  
                }else{
                  if(res.shipments && res.shipments.length>0){
                    // Display all shipments
                    displayAllShipments(res.shipments, res.order, orderid, email, phone);
                }else{
                   $("#shipmentError").html("<b style='color:red'>Shipment details are not available right now</b>");
                 	$("#all_shipments_container").hide();
               }
                }
                 generateOrderTable(res);
                // console.log(res.shipments[0].items);
                
                 // Display returns if available
                 if(res.returns && res.returns.length > 0) {
                   displayAllReturns(res.returns);
                 } else {
                   $("#all_returns_section").hide();
                 }

                 $(".page-content--medium, .breadcrumb + .page-header__text-wrapper").slideUp();
                 $(".account--order").slideDown(500);
                 
                 // Show "Track Another Order" button
                 $(".track_another_order_btn").fadeIn(300); 
               }else{
                 $("#trackerError").html("<b style='color:red'>Credentials provided not matching with any order!!!</b>");
               } 
               },
           error: function(xhr, status, error) {
               $("#trackerError").html("<b style='color:red'>Error fetching order details. Please try again.</b>");
           }
           });
     }else{
      $("#trackerError").html("<b style='color:red'>Invalid Order ID</b>");
     }
     setTimeout(function(){
                    $(".form__submit").attr("aria-busy","false");
                    $(".form__submit .loader-button__loader").attr("hidden","");
       if(formhasClass.hasClass("cancel_order")){
       }else{
                    // $("html, body").animate({ scrollTop: 0 }, "slow");
       }
                   
              },2000);
      });

// Function to get timeline configuration for return pickup shipments
function getReturnPickupTimelineConfig(shipment) {
  const status = shipment.status;
  
  // Determine timeline steps based on status
  let steps = [];
  let activeStep = 0;
  let finalStatusColor = '';
  let finalStatusText = '';
  
  // Return pickup timeline: Pickup Scheduled -> In Transit -> Received at Warehouse
  // Status values are same as forward shipments: CONFIRMED, IN_TRANSIT, DELIVERED, FAILURE
  steps = [
    {label: 'Pickup Scheduled', status: 'CONFIRMED'},
    {label: 'In Transit', status: 'IN_TRANSIT'},
    {label: status == 'DELIVERED' ? 'Received at Warehouse' : status == 'FAILURE' ? 'Failed' : 'Received at Warehouse', status: 'FINAL'}
  ];
  
  if(status == 'CONFIRMED') activeStep = 0;
  else if(status == 'IN_TRANSIT') activeStep = 1;
  else if(status == 'DELIVERED' || status == 'FAILURE') activeStep = 2;
  
  // Set final status color and text
  if(status == 'DELIVERED') {
    finalStatusColor = '#16a34a'; // Green
    finalStatusText = 'Received at Warehouse';
    steps[steps.length - 1].color = finalStatusColor;
    steps[steps.length - 1].label = finalStatusText;
  } else if(status == 'FAILURE') {
    finalStatusColor = '#dc2626'; // Red
    finalStatusText = 'Failed';
    steps[steps.length - 1].color = finalStatusColor;
    steps[steps.length - 1].label = finalStatusText;
  }
  
  return {steps, activeStep, finalStatusColor};
}

// Function to display all returns
function displayAllReturns(returns) {
  if(!returns || returns.length === 0) return;
  
  $("#all_returns_container").empty();
  
  returns.forEach((returnData, returnIndex) => {
    const returnId = `return_${returnIndex}`;
    
    // Get return status color
    let statusColor = '#6b7280'; // Default grey
    if(returnData.status === 'OPEN') statusColor = '#3b82f6'; // Blue
    else if(returnData.status === 'IN_PROGRESS') statusColor = '#f59e0b'; // Yellow
    else if(returnData.status === 'CLOSED') statusColor = '#16a34a'; // Green
    else if(returnData.status === 'DECLINED') statusColor = '#dc2626'; // Red
    
    // Get action label
    let actionLabel = returnData.action || 'N/A';
    let actionColor = '#6b7280';
    if(actionLabel === 'GIFT_CARD') {
      actionLabel = 'Gift Card';
      actionColor = '#8b5cf6'; // Purple
    } else if(actionLabel === 'REFUND') {
      actionLabel = 'Refund';
      actionColor = '#16a34a'; // Green
    }
    
    const requestDate = returnData.requestDate ? 
      new Date(returnData.requestDate).toLocaleDateString('en-IN', {day: 'numeric', month: 'short', year: 'numeric'}) : 'N/A';
    
    let returnHtml = `
      <div class="account__address account__address--auto return_item" style="margin-bottom: 40px; padding: 25px; background: #f9fafb; border-radius: 8px; border: 2px solid #e5e7eb;">
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 20px; flex-wrap: wrap; gap: 10px;">
          <h3 class="heading h6" style="margin: 0;">Return Request #${returnIndex + 1}</h3>
          <div style="display: flex; gap: 8px; flex-wrap: wrap;">
            <span style="display: inline-block; padding: 6px 12px; background: ${statusColor}; color: white; border-radius: 4px; font-size: 12px; font-weight: 600;">${returnData.status}</span>
            <span style="display: inline-block; padding: 6px 12px; background: ${actionColor}; color: white; border-radius: 4px; font-size: 12px; font-weight: 600;">${actionLabel}</span>
          </div>
        </div>
        
        <ul class="return_details" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); list-style: none; padding: 0; margin: 0 0 25px 0; gap: 12px;">
          <li style="padding: 10px; background: white; border-radius: 6px; font-size: 14px;"><strong style="display: block; margin-bottom: 6px; color: #666; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Request Date</strong><span style="display: block; color: #333; font-weight: 600;">${requestDate}</span></li>
          <li style="padding: 10px; background: white; border-radius: 6px; font-size: 14px;"><strong style="display: block; margin-bottom: 6px; color: #666; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Total Items</strong><span style="display: block; color: #333; font-weight: 600;">${returnData.totalQuantity}</span></li>
          <li style="padding: 10px; background: white; border-radius: 6px; font-size: 14px;"><strong style="display: block; margin-bottom: 6px; color: #666; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Total Amount</strong><span style="display: block; color: #333; font-weight: 600;">₹${returnData.totalAmount}</span></li>
          ${returnData.refundAmount ? `<li style="padding: 10px; background: white; border-radius: 6px; font-size: 14px;"><strong style="display: block; margin-bottom: 6px; color: #666; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Refund Amount</strong><span style="display: block; color: #16a34a; font-weight: 700;">₹${returnData.refundAmount}</span></li>` : ''}
        </ul>
        
        ${returnData.deductionAmount ? `
          <div style="padding: 12px; background: #fef3c7; border-left: 3px solid #f59e0b; border-radius: 4px; margin-bottom: 20px;">
            <strong style="color: #f59e0b;">Deduction: ₹${returnData.deductionAmount}</strong>
            ${returnData.deductionReason ? `<div style="font-size: 13px; color: #666; margin-top: 4px;">Reason: ${returnData.deductionReason}</div>` : ''}
          </div>
        ` : ''}
        
        ${returnData.notes ? `
          <div style="padding: 12px; background: white; border-left: 3px solid #6b7280; border-radius: 4px; margin-bottom: 20px;">
            <strong style="color: #333; display: block; margin-bottom: 6px;">Notes:</strong>
            <div style="font-size: 13px; color: #666;">${returnData.notes}</div>
          </div>
        ` : ''}
        
        <h4 class="heading" style="font-size: 15px; margin: 20px 0 15px 0; color: #333;">Return Items</h4>
        <div class="return_items_container_${returnId}" style="margin-bottom: 25px;">
          <!-- Return items will be populated here -->
        </div>
        
        ${returnData.shipments && returnData.shipments.length > 0 ? `
          <h4 class="heading" style="font-size: 15px; margin: 20px 0 15px 0; color: #333;">Pickup Shipments</h4>
          <div class="return_shipments_container_${returnId}">
            <!-- Return shipments will be populated here -->
          </div>
        ` : ''}
      </div>
    `;
    
    $("#all_returns_container").append(returnHtml);
    
    // Display return items
    if(returnData.items && returnData.items.length > 0) {
      displayReturnItems(returnData.items, returnId);
    }
    
    // Display return shipments (pickups)
    if(returnData.shipments && returnData.shipments.length > 0) {
      displayReturnShipments(returnData.shipments, returnId);
    }
  });
  
  // Show the returns section
  $("#all_returns_section").slideDown();
}

// Function to display return items
function displayReturnItems(items, returnId) {
  let itemsHtml = '';
  
  items.forEach(item => {
    let reasonColor = '#6b7280';
    if(item.reason === 'DEFECTIVE') reasonColor = '#dc2626';
    else if(item.reason === 'WRONG_ITEM') reasonColor = '#f59e0b';
    else if(item.reason === 'NOT_AS_DESCRIBED') reasonColor = '#f59e0b';
    
    itemsHtml += `
      <div style="display: flex; gap: 15px; padding: 15px; background: white; border-radius: 6px; margin-bottom: 12px; align-items: center;">
        <div style="width: 80px; height: 80px; flex-shrink: 0;">
          <img src="${item.image}" alt="${item.name}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px;">
        </div>
        <div style="flex: 1;">
          <div style="font-weight: 600; color: #333; margin-bottom: 6px;">${item.name}</div>
          ${item.color ? `<div style="font-size: 13px; color: #666;">Color: ${item.color}</div>` : ''}
          ${item.size ? `<div style="font-size: 13px; color: #666;">Size: ${item.size}</div>` : ''}
          <div style="font-size: 13px; color: #666;">Quantity: ${item.quantity}</div>
          ${item.reason ? `<div style="font-size: 12px; color: ${reasonColor}; margin-top: 4px; font-weight: 600;">Reason: ${item.reason.replace(/_/g, ' ')}</div>` : ''}
        </div>
        ${item.status ? `<div style="padding: 4px 10px; background: #e5e7eb; color: #333; border-radius: 4px; font-size: 11px; font-weight: 600; align-self: flex-start;">${item.status}</div>` : ''}
      </div>
    `;
  });
  
  $(`.return_items_container_${returnId}`).html(itemsHtml);
}

// Function to display return shipments (pickups)
function displayReturnShipments(shipments, returnId) {
  let shipmentsHtml = '';
  
  shipments.forEach((shipment, index) => {
    const shipmentId = `${returnId}_pickup_${index}`;
    const timelineConfig = getReturnPickupTimelineConfig(shipment);
    const timelineHTML = generateTimelineHTML(timelineConfig);
    
    shipmentsHtml += `
      <div style="padding: 20px; background: white; border-radius: 6px; margin-bottom: 15px; border: 1px solid #e5e7eb;">
        ${shipments.length > 1 ? `<h5 style="font-size: 14px; margin: 0 0 15px 0; color: #666;">Pickup #${index + 1}</h5>` : ''}
        
        <ul style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); list-style: none; padding: 0; margin: 0 0 20px 0; gap: 12px;">
          <li style="padding: 8px; background: #f9fafb; border-radius: 4px; font-size: 13px;"><strong style="display: block; margin-bottom: 4px; color: #666; font-size: 11px;">Tracking No</strong><span style="display: block; color: #333; font-weight: 600;">${shipment.trackingNumber}</span></li>
          <li style="padding: 8px; background: #f9fafb; border-radius: 4px; font-size: 13px;"><strong style="display: block; margin-bottom: 4px; color: #666; font-size: 11px;">Courier</strong><span style="display: block; color: #333; font-weight: 600;">${shipment.carrierName}</span></li>
          <li style="padding: 8px; background: #f9fafb; border-radius: 4px; font-size: 13px;"><strong style="display: block; margin-bottom: 4px; color: #666; font-size: 11px;">Status</strong><span style="display: block; color: ${timelineConfig.finalStatusColor || '#333'}; font-weight: 700;">${shipment.status}</span></li>
        </ul>
        
        ${shipment.pickupAddress ? `
          <div style="padding: 12px; background: #f9fafb; border-radius: 4px; margin-bottom: 15px;">
            <strong style="display: block; margin-bottom: 6px; color: #666; font-size: 12px;">Pickup Address:</strong>
            <div style="font-size: 13px; color: #333;">
              ${shipment.pickupAddress.address}<br>
              ${shipment.pickupAddress.city}, ${shipment.pickupAddress.state} - ${shipment.pickupAddress.postalCode}<br>
              ${shipment.pickupAddress.country}
            </div>
          </div>
        ` : ''}
        
        ${timelineHTML}
        
        ${shipment.trackingHistory && shipment.trackingHistory.length > 0 ? `
          <div class="tracking_history_section_${shipmentId}" style="margin-top: 20px; display:none;">
            <h5 style="font-size: 14px; margin: 0 0 10px 0;">Latest Scan</h5>
            <div class="latest_scan_container_${shipmentId}" style="padding: 12px; background: #f9f9f9; border-radius: 5px;">
              <!-- Latest scan will be populated here -->
            </div>
            <div style="margin-top: 12px;">
              <button type="button" class="button button--secondary button--small show_all_scans_btn" data-shipment-id="${shipmentId}">Show All Scans</button>
            </div>
          </div>
        ` : ''}
      </div>
    `;
  });
  
  $(`.return_shipments_container_${returnId}`).html(shipmentsHtml);
  
  // Display tracking history for each shipment
  shipments.forEach((shipment, index) => {
    const shipmentId = `${returnId}_pickup_${index}`;
    if(shipment.trackingHistory && shipment.trackingHistory.length > 0) {
      displayTrackingHistoryForShipment(shipment.trackingHistory, shipmentId);
    }
  });
}

// Function to display tracking history for a specific shipment
function displayTrackingHistoryForShipment(trackingHistory, shipmentId) {
  if(!trackingHistory || trackingHistory.length === 0) return;
  
  // Sort by scanDate in descending order (latest first)
  const sortedHistory = [...trackingHistory].sort((a, b) => new Date(b.scanDate) - new Date(a.scanDate));
  
  // Show the tracking history section
  $(`.tracking_history_section_${shipmentId}`).slideDown();
  
  // Display latest scan
  const latestScan = sortedHistory[0];
  const statusColor = getStatusColor(latestScan.status);
  const bgColor = statusColor === '#dc2626' ? '#fee2e2' : statusColor === '#16a34a' ? '#f0f8f0' : statusColor === '#f59e0b' ? '#fef3c7' : '#f9f9f9';
  
  const latestScanHtml = `
    <div style="margin-bottom: 8px;">
      <strong style="color: ${statusColor}; font-size: 14px;">${latestScan.status}</strong>
    </div>
    <div style="font-size: 13px; color: #666; margin-bottom: 5px;">
      ${latestScan.description}
    </div>
    <div style="font-size: 12px; color: #999;">
      <span><strong>Location:</strong> ${latestScan.location}</span> | 
      <span><strong>Time:</strong> ${formatScanDate(latestScan.scanDate)}</span>
    </div>
  `;
  $(`.latest_scan_container_${shipmentId}`).html(latestScanHtml);
  $(`.latest_scan_container_${shipmentId}`).css({
    'background': bgColor,
    'border-left': `3px solid ${statusColor}`
  });
  
  // Store all tracking history for modal with shipment ID
  if(!window.allTrackingHistories) window.allTrackingHistories = {};
  window.allTrackingHistories[shipmentId] = sortedHistory;
}

// Function to format scan date
function formatScanDate(dateString) {
  const date = new Date(dateString);
  const options = { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric', 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: true
  };
  return date.toLocaleString('en-IN', options);
}

// Function to get status color
function getStatusColor(status) {
  const statusUpper = status.toUpperCase();
  
  if(statusUpper.includes('RTO') || statusUpper.includes('RETURN')) {
    return '#dc2626'; // Red for RTO/Return
  } else if(statusUpper.includes('DELIVER')) {
    return '#16a34a'; // Green for Delivered
  } else if(statusUpper.includes('MANIFEST')) {
    return '#6b7280'; // Grey for Manifested
  } else {
    return '#f59e0b'; // Yellow for other statuses
  }
}

// Function to generate all tracking history HTML for specific shipment
function generateAllTrackingHistory(shipmentId) {
  if(!window.allTrackingHistories || !window.allTrackingHistories[shipmentId] || window.allTrackingHistories[shipmentId].length === 0) return '';
  
  let html = '<div class="tracking_timeline" style="position: relative; padding-left: 30px;">';
  
  window.allTrackingHistories[shipmentId].forEach((scan, index) => {
    const isFirst = index === 0;
    const isLast = index === window.allTrackingHistories[shipmentId].length - 1;
    
    // Get color based on status
    const statusColor = getStatusColor(scan.status);
    const bgColor = isFirst ? (statusColor === '#dc2626' ? '#fee2e2' : statusColor === '#16a34a' ? '#f0f8f0' : statusColor === '#f59e0b' ? '#fef3c7' : '#f9f9f9') : '#f9f9f9';
    
    html += `
      <div class="tracking_item" style="position: relative; padding-bottom: 30px; ${isLast ? 'padding-bottom: 0;' : ''}">
        <!-- Timeline dot -->
        <div style="position: absolute; left: -30px; top: 0; width: 12px; height: 12px; border-radius: 50%; background: ${statusColor}; border: 2px solid ${statusColor};"></div>
        
        <!-- Timeline line -->
        ${!isLast ? '<div style="position: absolute; left: -25px; top: 12px; width: 2px; height: calc(100% + 5px); background: #ddd;"></div>' : ''}
        
        <!-- Content -->
        <div style="background: ${bgColor}; padding: 15px; border-radius: 5px; border-left: 3px solid ${statusColor};">
          <div style="margin-bottom: 8px;">
            <strong style="color: ${statusColor}; font-size: 14px;">${scan.status}</strong>
            ${isFirst ? `<span style="background: ${statusColor}; color: white; font-size: 10px; padding: 2px 6px; border-radius: 3px; margin-left: 8px;">LATEST</span>` : ''}
          </div>
          <div style="font-size: 13px; color: #666; margin-bottom: 8px;">
            ${scan.description}
          </div>
          <div style="font-size: 12px; color: #999;">
            <div><strong>Location:</strong> ${scan.location}</div>
            <div><strong>Time:</strong> ${formatScanDate(scan.scanDate)}</div>
            ${scan.statusCode ? `<div><strong>Status Code:</strong> ${scan.statusCode}</div>` : ''}
          </div>
        </div>
      </div>
    `;
  });
  
  html += '</div>';
  return html;
}

// Show all scans button click handler
$("body").on("click", ".show_all_scans_btn", function() {
  const shipmentId = $(this).data('shipment-id');
  const allHistoryHtml = generateAllTrackingHistory(shipmentId);
  $("#all_tracking_scans").html(allHistoryHtml);
  $("#tracking_history_modal").fadeIn(300);
  $("body").css("overflow", "hidden");
});

// Close modal handlers
$("body").on("click", ".close_tracking_modal", function() {
  $("#tracking_history_modal").fadeOut(300);
  $("body").css("overflow", "auto");
});

// Close modal when clicking outside
$(window).on("click", function(e) {
  if ($(e.target).is("#tracking_history_modal")) {
    $("#tracking_history_modal").fadeOut(300);
    $("body").css("overflow", "auto");
  }
});

// Close modal with ESC key
$(document).on("keydown", function(e) {
  if (e.key === "Escape" && $("#tracking_history_modal").is(":visible")) {
    $("#tracking_history_modal").fadeOut(300);
    $("body").css("overflow", "auto");
  }
  if (e.key === "Escape" && $("#cancel_order_modal").is(":visible")) {
    $("#cancel_order_modal").fadeOut(300);
    $("body").css("overflow", "auto");
  }
  if (e.key === "Escape" && $("#create_return_modal").is(":visible")) {
    $("#create_return_modal").fadeOut(300);
    $("body").css("overflow", "auto");
  }
});

// Cancel Order Button - Show Confirmation Modal
$("body").on("click", ".cancel_order_btn", function() {
  $("#cancel_order_result").html("");
  $("#cancel_order_modal").fadeIn(300);
  $("body").css("overflow", "hidden");
});

// Cancel Order Modal - Close Handlers
$("body").on("click", ".close_cancel_modal, .cancel_modal_no", function() {
  $("#cancel_order_modal").fadeOut(300);
  $("body").css("overflow", "auto");
});

// Click outside modal to close
$(window).on("click", function(e) {
  if ($(e.target).is("#cancel_order_modal")) {
    $("#cancel_order_modal").fadeOut(300);
    $("body").css("overflow", "auto");
  }
});

// Cancel Order - Confirmed
$("body").on("click", ".cancel_modal_yes", function() {
  if(!window.currentOrder) {
    $("#cancel_order_result").html("<p style='color: #dc2626;'>Error: Order information not found.</p>");
    return;
  }
  
  // Disable button and show loading
  $(this).prop('disabled', true).html('Cancelling...');
  $(".cancel_modal_no").prop('disabled', true);
  
  $.ajax({
    url: API_BASE_URL + '/api/public/cancel-order',
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({
      orderNumber: window.currentOrder.orderNumber,
      email: window.currentOrder.email,
      phone: window.currentOrder.phone
    }),
    success: function(res) {
      if(res.success) {
        $("#cancel_order_result").html("<p style='color: #16a34a; font-weight: 600;'>✓ Order cancelled successfully!</p>");
        // Update order status badge
        $(".order_status").html('<span style="display: inline-block; padding: 6px 12px; background: #dc2626; color: white; border-radius: 4px; font-size: 13px; font-weight: 600;">Order Status: CANCELLED</span>');
        // Hide cancel button
        $(".cancel_order_btn").hide();
        $(".cancel_message").html("This order has been cancelled.").show();
        
        // Close modal after 2 seconds
        setTimeout(function() {
          $("#cancel_order_modal").fadeOut(300);
          $("body").css("overflow", "auto");
        }, 2000);
      } else {
        $("#cancel_order_result").html("<p style='color: #dc2626;'>Error: " + (res.message || "Could not cancel order") + "</p>");
        $(".cancel_modal_yes").prop('disabled', false).html('Yes, Cancel Order');
        $(".cancel_modal_no").prop('disabled', false);
      }
    },
    error: function(xhr, status, error) {
      const errorMsg = xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : "Failed to cancel order. Please try again.";
      $("#cancel_order_result").html("<p style='color: #dc2626;'>Error: " + errorMsg + "</p>");
      $(".cancel_modal_yes").prop('disabled', false).html('Yes, Cancel Order');
      $(".cancel_modal_no").prop('disabled', false);
    }
  });
});

// Create Return Button - Show Modal
$("body").on("click", ".create_return_btn", function() {
  if(!window.returnEligibility || !window.returnEligibility.eligibleItems || window.returnEligibility.eligibleItems.length === 0) {
    alert("No eligible items for return.");
    return;
  }
  
  // Reset form
  $("#create_return_form")[0].reset();
  $("#create_return_result").html("");
  $("#return_items_error").html("");
  
  // Hide refund summary
  $("#return_refund_summary").hide();
  $("#return_total_items").text("0");
  $("#return_total_amount").text("₹0");
  
  // Pre-fill pickup address with shipping address
  if(window.pickupAddressDefault) {
    $("#return_address1").val(window.pickupAddressDefault.address1).addClass('is-filled');
    $("#return_address2").val(window.pickupAddressDefault.address2).addClass('is-filled');
    $("#return_city").val(window.pickupAddressDefault.city).addClass('is-filled');
    $("#return_state").val(window.pickupAddressDefault.state).addClass('is-filled');
    $("#return_postalCode").val(window.pickupAddressDefault.postalCode).addClass('is-filled');
    $("#return_phone").val(window.pickupAddressDefault.phone).addClass('is-filled');
  }
  
  // Populate eligible items
  populateEligibleItems(window.returnEligibility.eligibleItems);
  
  // Show modal
  $("#create_return_modal").fadeIn(300);
  $("body").css("overflow", "hidden");
});

// Create Return Modal - Close Handlers
$("body").on("click", ".close_return_modal, .cancel_return_modal", function() {
  $("#create_return_modal").fadeOut(300);
  $("body").css("overflow", "auto");
});

// Click outside modal to close
$(window).on("click", function(e) {
  if ($(e.target).is("#create_return_modal")) {
    $("#create_return_modal").fadeOut(300);
    $("body").css("overflow", "auto");
  }
});

// Function to populate eligible items for return
function populateEligibleItems(eligibleItems) {
  let html = '';
  
  eligibleItems.forEach((item, index) => {
    const itemId = `return_item_${index}`;
    
    html += `
      <div class="return_eligible_item" style="padding: 12px; background: #f9fafb; border-radius: 6px; margin-bottom: 12px; border: 1px solid #e5e7eb;">
        <div style="display: flex; gap: 10px; align-items: flex-start;">
          <input type="checkbox" class="return_item_checkbox" data-item-index="${index}" style="width: 18px; height: 18px; margin-top: 5px; cursor: pointer; flex-shrink: 0;">
          <div style="width: 60px; height: 60px; flex-shrink: 0;">
            <img src="${item.imageUrl}" alt="${item.itemName}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 4px;">
          </div>
          <div style="flex: 1; min-width: 0;">
            <div style="font-weight: 600; color: #333; margin-bottom: 4px; font-size: 14px; word-wrap: break-word;">${item.itemName}</div>
            ${item.itemBarcode ? `<div style="font-size: 12px; color: #666;">SKU: ${item.itemBarcode}</div>` : ''}
            <div style="font-size: 12px; color: #16a34a; font-weight: 600; margin-top: 4px;">Qty: ${item.eligibleQuantity} | ₹${item.totalAmount}</div>
            
            <div class="return_item_details_${itemId}" style="margin-top: 12px; display: none;">
              <div class="input" style="margin-bottom: 10px;">
                <select class="input__field is-filled return_item_qty" data-item-index="${index}" data-total-amount="${item.totalAmount}" data-eligible-quantity="${item.eligibleQuantity}" required>
                  ${Array.from({length: item.eligibleQuantity}, (_, i) => i + 1).map(q => 
                    `<option value="${q}">${q}</option>`
                  ).join('')}
                </select>
                <label class="input__label">Quantity*</label>
              </div>
              <div class="input">
                <select class="input__field return_item_reason" data-item-index="${index}" required>
                  <option value="">Select Reason*</option>
                  <option value="SIZE_TOO_LARGE">Size is too large</option>
                  <option value="SIZE_TOO_SMALL">Size is too small</option>
                  <option value="COLOR">Color mismatch</option>
                  <option value="STYLE">Style mismatch</option>
                  <option value="DEFECTIVE">Item is defective/damaged</option>
                  <option value="NOT_AS_DESCRIBED">Item not as described</option>
                  <option value="WRONG_ITEM">Wrong item received</option>
                  <option value="UNWANTED">Changed mind</option>
                  <option value="OTHER">Other reason</option>
                </select>
                <label class="input__label">Return Reason*</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  });
  
  $("#return_eligible_items_container").html(html);
}

// Handle item checkbox change
$("body").on("change", ".return_item_checkbox", function() {
  const itemIndex = $(this).data('item-index');
  const itemId = `return_item_${itemIndex}`;
  
  if($(this).is(':checked')) {
    $(`.return_item_details_${itemId}`).slideDown(200);
    $(`.return_item_reason[data-item-index="${itemIndex}"]`).prop('required', true);
  } else {
    $(`.return_item_details_${itemId}`).slideUp(200);
    $(`.return_item_reason[data-item-index="${itemIndex}"]`).prop('required', false);
    $(`.return_item_reason[data-item-index="${itemIndex}"]`).val('').removeClass('is-filled');
  }
  
  // Update refund summary
  updateReturnRefundSummary();
});

// Handle quantity select change
$("body").on("change", ".return_item_qty", function() {
  // Update refund summary when quantity changes
  updateReturnRefundSummary();
});

// Handle reason select change
$("body").on("change", ".return_item_reason", function() {
  if($(this).val()) {
    $(this).addClass('is-filled');
  } else {
    $(this).removeClass('is-filled');
  }
});

// Function to calculate and update refund summary
function updateReturnRefundSummary() {
  const selectedItems = $(".return_item_checkbox:checked");
  
  if(selectedItems.length === 0) {
    $("#return_refund_summary").slideUp(200);
    return;
  }
  
  let totalItems = 0;
  let totalAmount = 0;
  
  selectedItems.each(function() {
    const itemIndex = $(this).data('item-index');
    const selectedQuantity = parseInt($(`.return_item_qty[data-item-index="${itemIndex}"]`).val()) || 1;
    const itemTotalAmount = parseFloat($(`.return_item_qty[data-item-index="${itemIndex}"]`).data('total-amount')) || 0;
    const eligibleQuantity = parseInt($(`.return_item_qty[data-item-index="${itemIndex}"]`).data('eligible-quantity')) || 1;
    
    // Calculate per unit price: totalAmount / eligibleQuantity
    // Then multiply by selected quantity
    const itemRefundAmount = (itemTotalAmount / eligibleQuantity) * selectedQuantity;
    
    totalItems += selectedQuantity;
    totalAmount += itemRefundAmount;
  });
  
  // Update summary display
  $("#return_total_items").text(totalItems);
  $("#return_total_amount").text("₹" + Math.round(totalAmount));
  
  // Show summary section
  $("#return_refund_summary").slideDown(200);
}

// Create Return Form Submission
$("body").on("submit", "#create_return_form", function(e) {
  e.preventDefault();
  
  $("#return_items_error").html("");
  $("#create_return_result").html("");
  
  // Validate at least one item is selected
  const selectedItems = $(".return_item_checkbox:checked");
  if(selectedItems.length === 0) {
    $("#return_items_error").html("Please select at least one item to return.");
    return;
  }
  
  // Validate all selected items have reason
  let hasError = false;
  selectedItems.each(function() {
    const itemIndex = $(this).data('item-index');
    const reason = $(`.return_item_reason[data-item-index="${itemIndex}"]`).val();
    if(!reason) {
      $("#return_items_error").html("Please select return reason for all selected items.");
      hasError = true;
      return false;
    }
  });
  
  if(hasError) return;
  
  // Prepare return items array
  const returnItems = [];
  selectedItems.each(function() {
    const itemIndex = $(this).data('item-index');
    const eligibleItem = window.returnEligibility.eligibleItems[itemIndex];
    const quantity = parseInt($(`.return_item_qty[data-item-index="${itemIndex}"]`).val());
    const reason = $(`.return_item_reason[data-item-index="${itemIndex}"]`).val();
    
    returnItems.push({
      saleOrderItemId: eligibleItem.saleOrderItemId,
      quantity: quantity,
      reason: reason
    });
  });
  
  // Prepare pickup address
  const pickupAddress = {
    address1: $("#return_address1").val(),
    address2: $("#return_address2").val() || "",
    city: $("#return_city").val(),
    state: $("#return_state").val(),
    postalCode: $("#return_postalCode").val(),
    country: "India",
    phone: $("#return_phone").val()
  };
  
  // Prepare request data
  const requestData = {
    orderNumber: window.currentOrder.orderNumber,
    phone: window.currentOrder.phone,
    email: window.currentOrder.email,
    pickupAddress: pickupAddress,
    items: returnItems,
    deductionAmount: 0,
    actionType: "GIFT_CARD",
    enableQC: true
  };
  
  // Disable submit button and show loading
  $(".submit_return_btn").prop('disabled', true).html('Submitting...');
  
  // Submit return request
  $.ajax({
    url: API_BASE_URL + '/api/public/create-return',
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify(requestData),
    success: function(res) {
      if(res.success) {
        $("#create_return_result").html("<p style='color: #16a34a; font-weight: 600;'>✓ Return request created successfully!</p>");
        
        // Update return eligibility
        if(res.returnEligibility) {
          window.returnEligibility = res.returnEligibility;
          
          // Update button visibility
          if(!res.returnEligibility.canCreateReturn) {
            $(".create_return_btn").hide();
            if(res.returnEligibility.reason) {
              $(".return_eligibility_message").html(res.returnEligibility.reason).show();
            }
          }
        }
        
        // Display new returns
        if(res.returns && res.returns.length > 0) {
          displayAllReturns(res.returns);
        }
        
        // Close modal after 2 seconds
        setTimeout(function() {
          $("#create_return_modal").fadeOut(300);
          $("body").css("overflow", "auto");
          $(".submit_return_btn").prop('disabled', false).html('Submit Return');
        }, 2000);
      } else {
        $("#create_return_result").html("<p style='color: #dc2626;'>Error: " + (res.message || "Could not create return") + "</p>");
        $(".submit_return_btn").prop('disabled', false).html('Submit Return Request');
      }
    },
    error: function(xhr, status, error) {
      let errorMsg = "Failed to create return request. Please try again.";
      try {
        const response = xhr.responseJSON;
        errorMsg = response.error || response.message || response.details || errorMsg;
      } catch(e) {
        // Use default error message
      }
      $("#create_return_result").html("<p style='color: #dc2626;'>Error: " + errorMsg + "</p>");
      $(".submit_return_btn").prop('disabled', false).html('Submit Return Request');
    }
  });
});

// Old cancel order form handler removed - now using track order page with cancel functionality

// Track Another Order Button Handler
$("body").on("click", ".track_another_order_btn", function() {
  // Hide order details
  $(".account--order").slideUp(300);
  
  // Show the form again
  $(".page-content--medium, .breadcrumb + .page-header__text-wrapper").slideDown(300);
  
  // Clear form fields
  $('#orderid').val('');
  $('#billing_email').val('');
  $('#billing_phone').val('');
  
  // Clear any error messages
  $("#trackerError, #shipmentError").html("");
  
  // Hide the button
  $(this).fadeOut(300);
  
  // Smooth scroll to top
  $("html, body").animate({ scrollTop: 0 }, "slow");
});
 
function generateReturnableItems(item){
  let data = "";
  let qty = "";
 // console.log(item);
  if(Number(item.can_return) > 0){
     data= `<tr class="line-item">
                        <td>
<input type="checkbox" class="return_product_id" data-sku="${item.sku}" value="${item.id}" name="items" data-link="${item.product.handle}" style="height:18px;width:18px" />
                        </td>   
                        <td class="line-item__product">
                           <div class="line-item__content-wrapper">
<a href="/products/${item.product.handle}" class="line-item__image-wrapper" >
                              <img  class="line-item__image" loading="sizes" sizes="(max-width: 740px) 80px, 92px" height="2000" width="2000" alt="" src="${item.product.baseimage[0].src}" >
                              </a>
                              <div class="line-item__info">
                                 <div class="product-item-meta">
                                    <a href="/products/${item.product.handle}" class="product-item-meta__title text--small hidden-tablet-and-up">${item.product.title}</a>
                                    <a href="/products/${item.product.handle}" class="product-item-meta__title hidden-phone">${item.product.title}</a>
                                    <div class="product-item-meta__price-list-container">
                                        
                                       <div class="price-list">
<select style="line-height:1" disabled data-link="${item.product.handle}"  class="return-reason input__field"  name="reason" >
                                  <option value="">Select Reason</option>
                                  
                                  <option>Did not like product</option>
                                  
                                  <option>Did not like quality</option>
                                  
                                  <option>Did not like fabric</option>
                                  
                                  <option>Did not like embroidery</option>
                                  
                                  <option>Did not like colour</option>
                                  
                                  <option>Colour is different from the photo</option>
                                  
                                  <option>Design is different from the photo</option>
                                  
                                  <option>Product is torn or damaged</option>
                                  
                                  <option>Product received in poor condition</option>
                                  
                                  <option>Product has spots or marks</option>
                                  
                                  <option>Size is loose</option>
                                  
                                  <option>Size is tight</option>
                                  
                                  <option>Wrong product</option>
                                  
                                  <option>Item is missing</option>
                                  
                                  <option>Size issue</option>
                                  
                                  <option>Other</option>
                                  
                                </select>
                                           </div>
                                    </div>
                                 </div>`;
    qty+="<select disabled name='quantity' data-link='"+item.product.handle+"' style='width:80px;height: 26px;line-height:1' class='qty_selector input__field'>";
    for(let i=1; i<= Number(item.can_return_qty); i++){
     qty+="<option value='"+i+"'>"+i+"</option>";
    }
    qty+="</select>";
      
                        data+=`<div class="line-item__quantity hidden-tablet-and-up text--xsmall">Quantity: ${qty}</div>
                              </div>
                           </div>
                        </td> 
                        <td class="line-item__price-list-container text--center hidden-phone">
                           <div class="price-list price-list--stack">${qty}
                           </div>
                        </td>
                     </tr>`;
    return data;
  }
} 

$('[name="credit_action"]').on("click",function(){
  if($('[name="credit_action"]:checked').val() != "Store Credit" ){
    $(".bank-details").slideDown(100,function(){
     $(".bank-details .input__field").removeAttr("data-required");
      $(".bank-details .input__field").attr("required","");
    })
  }else{
    $(".bank-details").slideUp(100,function(){
     $(".bank-details .input__field").removeAttr("required");
      $(".bank-details .input__field").attr("data-required","");
    })
  }
    
});
function toggleAddress(){
  $(".pickup-address-form").slideToggle(100,function(){
       $(".pickup-address-form").toggleClass("update_pickup");
    if( $(".pickup-address-form").hasClass("update_pickup")){
        $(".pickup-address-form .input__field").removeAttr("data-required");
       $(".pickup-address-form .input__field").attr("required","");
    }else{
       $(".pickup-address-form .input__field").removeAttr("required");
       $(".pickup-address-form .input__field").attr("data-required","");
    }
  })
}

$("body").on("click",".return_product_id",function(){
  $("#chooseError").html("");
  let checkedLength = $(".return_product_id:checked").length;
  if($(this).is(":checked")){
   let product_handle = $(this).data("link");
    $("select[data-link='"+product_handle+"']").removeAttr("disabled").attr("required",""); 
  }else{
   let product_handle = $(this).data("link");
    $("select[data-link='"+product_handle+"']").attr("disabled","disabled").removeAttr("required");
  } 
  if(checkedLength > 0){
   $("#credit_action_2").removeAttr("disabled");
  }else{
  $("#credit_action_2").attr("disabled","");
  }
});
$(".save-pickup-address").on("click",function(){
  let flag = 0;
  $(".save-pickup-address").find("[required]").each(function(){
    if($(this).val() =="" ){
      $(this).css("background-color","#ffe2e2");
      flag++;
    }else{
      $(this).css("background-color","#ffe2e2");
    }
  });
  if(flag == 0){
 // $(this).css({"opacity":0.6,"pointer-events":"none"});
   $("#customer_name").html($(".pickup-address-form [name='full_name']").val());
   $("#customer_phone").html($(".pickup-address-form [name='phone']").val());
   $("#customer_email").html($(".pickup-address-form [name='email']").val());
  let pickupAddress = $(".pickup-address-form [name='street_address']").val()+" "+$(".pickup-address-form [name='landmark']").val()+"<br/>"+$(".pickup-address-form [name='pincode']").val()+" "+$(".pickup-address-form [name='city']").val()+" "+$(".pickup-address-form [name='state']").val()+"<br/>"+$(".pickup-address-form [name='country']").val()
  $("#customer_address").html(pickupAddress);
    $(".pickup-address-form").slideUp(100,function(){
       $(".pickup-address-form .input__field").removeAttr("required");
       $(".pickup-address-form .input__field").attr("data-required","");
    });
  }
});

 let order_number = "";


$("#return-order-form").on("submit",function(e){
       e.preventDefault();

     if($('[name="orderid"]').val().match(/(\d+)/)){
       let orderid = $('[name="orderid"]').val().match(/(\d+)/)[0].replace(/" "/g,"");
     let email = $('[name="billing_email"]').val().replace(/" "/g,"");
      let phone = $('[name="billing_phone"]').val().replace(/" "/g,""); 
      $.ajax({
             url: 'https://reports.peachmode.com/shopify/return/check/'+orderid, 
             type: 'get',
             data:{email:email,phone:phone}, 
             success: function(res){ 
              $("#trackerError").html("");
              
               if(res.orderproducts){
                
let  can_return = 0;
 let returnableItems = "";
  // res =   dummuyData();              
  
    if(res.orderproducts){
      
      $(".order_name").html("Order "+res.name)
      $(".order_date").html(res.created_at);
      $(".billing_address p").html(res.billing_address_name+"<br/>"+res.billing_address_address1+" "+res.billing_address_address2+"<br/>"+res.billing_address_zip+" "+res.billing_address_city+" "+res.billing_address_province+"<br/>"+res.billing_address_country);
      $(".shipping_address p").html(res.shipping_address_name+"<br/>"+res.shipping_address_address1+" "+res.shipping_address_address2+"<br/>"+res.shipping_address_zip+" "+res.shipping_address_city+" "+res.shipping_address_province+"<br/>"+res.shipping_address_country);
      $("#customer_address").html(res.shipping_address_address1+" "+res.shipping_address_address2+"<br/>"+res.shipping_address_zip+" "+res.shipping_address_city+" "+res.shipping_address_province+"<br/>"+res.shipping_address_country);
      $("#customer_name").html(res.billing_address_name);
      $("#customer_phone").html(res.shipping_address_phone);
      $("#customer_email").html(res.contact_email);
      $(".pickup-address-form [name='first_name']").val(res.billing_address_first_name);
      $(".pickup-address-form [name='last_name']").val(res.billing_address_last_name);
      $(".pickup-address-form [name='full_name']").val(res.billing_address_name);
      $(".pickup-address-form [name='street_address']").val(res.billing_address_address1);
      $(".pickup-address-form [name='email']").val(res.email);
      $(".pickup-address-form [name='phone']").val((res.billing_address_phone).replace("+91","").replace(/ /g,""));
      $(".pickup-address-form [name='country'] option[value='"+res.shipping_address_country+"']").removeAttr("selected");
      $(".pickup-address-form [name='country'] option[value='"+res.shipping_address_country+"']").attr("selected","selected").change();
      $(".pickup-address-form [name='state'] option[value='"+res.shipping_address_province+"']").attr("selected","selected").change();
      $(".pickup-address-form [name='city']").val(res.shipping_address_city);
      $(".pickup-address-form [name='pincode']").val(res.shipping_address_zip);
      $(".pickup-address-form [name='landmark']").val(res.shipping_address_address2);
       generateOrderTable(res);
                 let  can_return = 0;
                 let returnableItems = "";
                 for (item of res.orderproducts){
                   order_number = item.order_id;
                  // console.log(item);
                    if(Number(item.can_return) > 0)
                       can_return++;
                   
                   returnableItems+= generateReturnableItems(item);
                  }
      //console.log(can_return);
                  $(".shipment_html").html(returnableItems); 
                if(Object.keys(res.returns).length>0){
     let shipmentItems = res.returns[0];
                 generateShipmentTable(null,res.fulfillment_status,true,orderid,email,phone,res.returns);
                }else{
                  if(can_return == 0){
                 $(".return_requests").slideUp();
                $("#trackerError").html("<b style='color:red'>Order Can't be Returned. For any queries please contact customer care</b>");
               }
                }
             //  $(".page-track-your-order .page-content--medium,.page-track-your-order .breadcrumb  + .page-header__text-wrapper").slideUp();
                 $(".page-track-your-order .account--order").slideDown(500); 
                $("#return-order-form").slideUp();
              
      } 
             }
               },
        error:function(res){
           $(".return_requests").slideUp();
           $("#trackerError").html("");
           $("#trackerError").html("<b style='color:red'>"+JSON.parse(res.responseText).error+"</b>");
        }
           });
     }else{
      $("#trackerError").html("<b style='color:red'>Invalid Order ID</b>");
     }
     setTimeout(function(){
                    $(".form__submit").attr("aria-busy","false");
                    $(".form__submit .loader-button__loader").attr("hidden","");
                  // $("html, body").animate({ scrollTop: 0 }, "slow");
              },2000);
      });
      
 
     
$("#return_request").on("submit",function(e){
   e.preventDefault();
 
  if($(".return_product_id:checked").length > 0){
  let address1 = $(".pickup-address-form [name='street_address']").val();
  let address2 = $(".pickup-address-form [name='landmark']").val();
  let city = $(".pickup-address-form [name='city']").val();
  let country = $(".pickup-address-form [name='country']").val();
  let email = $(".pickup-address-form [name='email']").val();
  let first_name = $(".pickup-address-form [name='first_name']").val();
  let last_name = $(".pickup-address-form [name='last_name']").val();
  let name = $(".pickup-address-form [name='full_name']").val();
  let phone = $(".pickup-address-form [name='phone']").val();
  let province = $(".pickup-address-form [name='state']").val();
  let zip = $(".pickup-address-form [name='pincode']").val();
  let account_no = $(".bank-details #account_no").val();
  let bank_address = $(".bank-details #bank_address").val();
  let bank_name = $(".bank-details #bank_name").val();
  let ifsc = $(".bank-details #ifsc").val();
  let payee_name = $(".bank-details #payee_name").val();
    let toDo = $('[name="credit_action"]:checked').val();
  let returnProducts = [];
  
  $(".return_product_id:checked").each(function(){
    let returns = {};
    let link = $(this).data("link");
    returns.id = Number($(this).val());
    returns.quantity = Number($(".qty_selector[data-link='"+link+"']").val());
    returns.reason = $(".return-reason[data-link='"+link+"']").val();
    returns.sku = $(this).data("sku");
    returns.toreturn = "1";
     returnProducts.push(returns);
});
  
  let data = {orderId: order_number,
                returnInfo: {
                        address: {
                               address1,address2,city,country,email,first_name,last_name,name,phone,province,zip
                            },
                        bankDetails: {
                          account_no,bank_address,bank_name,ifsc,payee_name
                          },
                         pickup_charge: 0,
                         toDo,
                         toPickup: 1                         
                         },
              returnProducts
               }
//console.log(data);
  
    $.ajax({
             url: 'https://reports.peachmode.com/shopify/returns', 
             type: 'post',
             data:data, 
             success: function(res){ 
                  $("#return-order-form").submit();
                  $("#chooseError").html("<b style='color:green'>"+res.body.notice+"</b>");
               },
        error:function(res){
           $("#chooseError").html("<b style='color:red'>"+JSON.parse(res.responseText).message+"</b>");
        }
           });
  }else{
    $("#chooseError").html("<b style='color:red'>Please select atleast 1 product to return</b>");
    $(".return_product_id").focus();

  }
  
  setTimeout(function(){
                    $(".form__submit").attr("aria-busy","false");
                    $(".form__submit .loader-button__loader").attr("hidden","");
                   $("html, body").animate({ scrollTop: 500 }, "slow");
              },2000);
});

$("#otp_login").on("submit",function(e){
  let parentForm = $(this);
  e.preventDefault();
  $("#otpError").html("");
  let  phone = $("#customer_phone").val();
       phone = phone.replace(/ /g, '');
       phone = parseInt(phone, 10); 
  $("#customer_phone").val(phone) 
  if($("#customer_phone").val().length == 10){
            let filteredMobile = $("#customer_phone").val();
    if(parentForm.hasClass("need_otp")){
             $.ajax({
             url: API_BASE_URL + '/api/public/send-otp', 
             type: 'POST',
             contentType: 'application/json',
             data: JSON.stringify({
               phoneNumber: filteredMobile
             }),
             success: function(res){ 
               if(res.success) {
                 parentForm.removeClass("need_otp");
                 let message = res.message || "OTP Successfully sent!";
                 if(res.customerName) {
                   message += " to " + res.customerName;
                 }
                 if(res.validFor) {
                   message += " (Valid for " + (res.validFor / 60) + " minutes)";
                 }
                 $("#otpError").html("<b style='color:green'>" + message + "</b>");
                 $("#customer_otp").removeAttr("disabled");
                 $(".customer_otp_container").slideDown();
               } else {
                 $("#otpError").html("<b style='color:red'>Failed to send OTP. Please try again.</b>");
               }
            },
              error:function(xhr, status, error){ 
                 let errorMsg = "Failed to send OTP. Please try again.";
                 try {
                   const response = JSON.parse(xhr.responseText);
                   errorMsg = response.error || response.message || errorMsg;
                 } catch(e) {
                   // Use default error message
                 }
                 $("#otpError").html("<b style='color:red'>" + errorMsg + "</b>");
              }
            });   
    }else{
      let otp = $("#customer_otp").val();
      $.ajax({
        url: API_BASE_URL + '/api/public/verify-otp',
        method: "POST",
        contentType: 'application/json',
        data: JSON.stringify({
          phoneNumber: filteredMobile,
          otp: otp
        }),
        dataType: "json",
        success: function(res){
          if(res.success && res.url){
            let message = res.message || "OTP verified successfully!";
            if(res.customerName) {
              message += " Welcome, " + res.customerName + "!";
            }
            $("#otpError").html("<b style='color:green'>" + message + "</b>");
            setTimeout(function(){
              location.href = res.url;
            }, 500);
          } else {
            $("#otpError").html("<b style='color:red'>Verification failed. Please try again.</b>");
          }
        },
        error: function(xhr, status, error){
          let errorMsg = "Invalid OTP. Please try again.";
          try {
            const response = JSON.parse(xhr.responseText);
            errorMsg = response.error || response.message || errorMsg;
          } catch(e) {
            // Use default error message
          }
          $("#otpError").html("<b style='color:red'>" + errorMsg + "</b>");
        }
      })
    }
  }else{
    $("#otpError").html("<span style='color:red'>Invalid Mobile No.</span>");
  }
   setTimeout(function(){
                    $(".form__submit").attr("aria-busy","false");
                    $(".form__submit .loader-button__loader").attr("hidden","");
                  // $("html, body").animate({ scrollTop: 0 }, "slow");
              },2000);
});

// ============================================
// Peachmode Rewards — Loyalty API Client
// ============================================
(function() {
  var LOYALTY_API_BASE = API_BASE_URL + '/api/public/loyalty';

  function getAuthHeaders() {
    var auth = window.__PEACHMODE_LOYALTY_AUTH;
    if (!auth || !auth.sig) return null;
    return {
      'Content-Type': 'application/json',
      'x-shopify-customer-id': auth.customerId,
      'x-shopify-email': auth.email,
      'x-shopify-phone': auth.phone || '',
      'x-shopify-ts': auth.ts,
      'x-shopify-sig': auth.sig
    };
  }

  function isTokenFresh() {
    var auth = window.__PEACHMODE_LOYALTY_AUTH;
    if (!auth) return false;
    var now = Math.floor(Date.now() / 1000);
    return Math.abs(now - parseInt(auth.ts, 10)) < 540;
  }

  async function fetchLoyaltyProfile() {
    var headers = getAuthHeaders();
    if (!headers) return null;
    try {
      var response = await fetch(LOYALTY_API_BASE + '/profile', { headers: headers });
      if (!response.ok) return null;
      return response.json();
    } catch (e) {
      console.warn('[PeachmodeRewards] Profile fetch failed:', e);
      return null;
    }
  }

  async function fetchTransactions(opts) {
    opts = opts || {};
    var headers = getAuthHeaders();
    if (!headers) return null;
    var params = new URLSearchParams({
      page: String(opts.page || 1),
      pageSize: String(opts.pageSize || 10)
    });
    if (opts.type) params.set('type', opts.type);
    try {
      var response = await fetch(LOYALTY_API_BASE + '/transactions?' + params, { headers: headers });
      if (!response.ok) return null;
      return response.json();
    } catch (e) {
      console.warn('[PeachmodeRewards] Transactions fetch failed:', e);
      return null;
    }
  }

  async function fetchPendingAllocations() {
    var headers = getAuthHeaders();
    if (!headers) return null;
    try {
      var response = await fetch(LOYALTY_API_BASE + '/pending', { headers: headers });
      if (!response.ok) return null;
      return response.json();
    } catch (e) {
      console.warn('[PeachmodeRewards] Pending fetch failed:', e);
      return null;
    }
  }

  window.PeachmodeRewards = {
    isLoggedIn: function() { return !!window.__PEACHMODE_LOYALTY_AUTH; },
    isTokenFresh: isTokenFresh,
    fetchProfile: fetchLoyaltyProfile,
    fetchTransactions: fetchTransactions,
    fetchPending: fetchPendingAllocations
  };

  // Header widget auto-init
  document.addEventListener('DOMContentLoaded', async function() {
    if (!window.PeachmodeRewards.isLoggedIn()) return;
    var widget = document.getElementById('loyalty-header-widget');
    var balanceEl = document.getElementById('loyalty-points-balance');
    if (!widget || !balanceEl) return;
    var profile = await window.PeachmodeRewards.fetchProfile();
    if (!profile) return;
    balanceEl.textContent = profile.balance.available.toLocaleString();
    widget.style.display = '';
  });

  // Account page loyalty summary auto-init
  document.addEventListener('DOMContentLoaded', async function() {
    var el = document.getElementById('account-loyalty-summary');
    var balEl = document.getElementById('account-loyalty-balance');
    if (!el || !balEl || !window.PeachmodeRewards || !window.PeachmodeRewards.isLoggedIn()) return;
    var profile = await window.PeachmodeRewards.fetchProfile();
    if (!profile) return;
    balEl.textContent = profile.balance.available.toLocaleString();
    el.style.display = '';
  });
})();